import { STATUS_CATEGORY } from 'app/base/orders/constants';
import i18n from '@shared/i18n';

export const tabConfig = [
    {
        query: STATUS_CATEGORY.UNPAID,
        name: i18n.gettext('尚未付款'),
    },
    {
        query: STATUS_CATEGORY.PAID,
        name: i18n.gettext('已付款'),
    },
    {
        query: STATUS_CATEGORY.UNPICKED,
        name: i18n.gettext('待收貨'),
    },
    {
        query: STATUS_CATEGORY.COMPLETE,
        name: i18n.gettext('已完成'),
    },
    {
        query: STATUS_CATEGORY.REFUND,
        name: i18n.gettext('退款退貨'),
    },
    {
        query: STATUS_CATEGORY.CANCEL,
        name: i18n.gettext('已取消'),
    },
];
